<div class="row">
  <div class="col-sm-6 col-md-6">
    <app-card [title]="'admin.style.show.style_information'|translate">
      <app-classic-box #classicForm  [classicBox]="classicBox" [data]="lastValue" (changeForm)="enableButton($event)"></app-classic-box>
    </app-card>
  </div>
  <div class="col-sm-6">
    <app-card [title]="'admin.collection.show.properties_information'|translate">
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
          <tr>
            <th></th>
            <th>{{'doctrine.property.name'|translate}}</th>
            <th>{{'doctrine.property.status'|translate}}</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let property of properties">
            <td class="checkbox">
              <label>
                <input type="checkbox" name="propertyItem" #propertyItem="ngModel" (change)="onToggle()"
                       [(ngModel)]="property.checked">
              </label>
            </td>
            <td>
              {{property.name}}
            </td>
            <td>
              {{(property.status)?getProperty().PROPERTY_AMOUNT:getProperty().PROPERTY_METERS}}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </app-card>
  </div>
</div>
<div class="card-block-hid ng-trigger ng-trigger-cardToggle" style="overflow: hidden;">
  <div class="card-block pull-right">
    <button (click)="submitItem(false)" class="btn btn-link me-4" type="button">{{'global.cancel'|translate}}</button>
    <button [disabled]="!enableSave || (selectedValues.length === 0)"  (click)="submitItem(true)" class="btn btn-primary ripple light" type="button">{{(isEdit ? 'global.save_changes' : 'global.add') | translate}}</button>
  </div>
</div>
